import script from "./arrowChart.vue?vue&type=script&setup=true&lang=js"
export * from "./arrowChart.vue?vue&type=script&setup=true&lang=js"

import "./arrowChart.vue?vue&type=style&index=0&id=9d885098&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d885098"]])

export default __exports__